import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { CloseButton } from 'components/CloseButton';
import { Modal } from 'components/Modal';
import { Region } from './Region';

// Constants
import { DATA_CENTERS } from 'i18n/constants';
import { LOCALE_PICKER_TEST_IDS } from './const';

// Helpers
import { getLocale } from 'i18n/helpers';

// Hooks
import { useToggle } from '@clover-util/use-toggle';

// Types
import { DataCenterCode } from 'i18n/types';

// Styles
import styles from './LocalePicker.module.scss';

const headingId = 'locale-picker-modal-heading';
const SUPPORTED_DATA_CENTERS = {
  [DataCenterCode.NORTH_AMERICA]: DATA_CENTERS[DataCenterCode.NORTH_AMERICA],
};

export const LocalePicker: React.FC = memo(() => {
  const { i18n, t } = useTranslation();
  const currentLocale = getLocale(i18n.language);

  const [localePickerIsOpen, , showLocalePicker, hideLocalePicker] = useToggle(false);

  if (currentLocale.code !== i18n.language) console.error(`Unable to determine the locale information for locale code ${i18n.language}`);

  return (
    <>
      <button className={styles.localePickerButton} onClick={showLocalePicker} data-testid={LOCALE_PICKER_TEST_IDS.root}>
        <img aria-hidden src={currentLocale.country.icon} alt={currentLocale.country.code} />
        <span>{currentLocale.displayName}</span>
      </button>
      {localePickerIsOpen && (
        <Modal className={styles.modal} isOpen onClose={hideLocalePicker} aria={{ labelledby: headingId }}>
          <header className={styles.modalHeader}>
            <h2 id={headingId}>{t('localePicker.chooseYourCountry')}</h2>
            <CloseButton onClick={hideLocalePicker} />
          </header>
          <div className={styles.body}>
            {Object.values(SUPPORTED_DATA_CENTERS).map(dc => (
              <Region key={dc.code} dataCenter={dc} closeModal={hideLocalePicker} />
            ))}
          </div>
        </Modal>
      )}
    </>
  );
});
